
import { defineComponent, defineAsyncComponent, SetupContext, computed, getCurrentInstance } from 'vue';
import TopBar from './topbar.vue';
import { useLogin } from '@/hooks/useLogin';

const ECommerceHeader = defineComponent({
    components: {
        TopBar,
        LoginPopup: defineAsyncComponent(() => import(/* webpackChunkName: "components/login-popup" */ '@/components/login/index.vue')),
        LogoutPopup: defineAsyncComponent(() => import(/* webpackChunkName: "components/logout-popup" */ '@/components/logout-popup/index.vue')),
    },
    setup(_: unknown, ctx: SetupContext<Array<'onClickSearchBtn'>>) {
        const { proxy } = getCurrentInstance() || {};

        const handleClickSearchBtn = (value?: string) => {
            ctx.emit('onClickSearchBtn', value);
        };

        const {
            showLoginPopup,
            showLogoutPopup,
            isLoginStatus,
            currentUserHeadUrl,
            handleLoginPopupClose,
            changeLoginStatus,
            handleLoginPopupOpenkwai,
            changeLoginPopupShow,
            handleLogout,
            handleLogoutCancel,
            handleLogoutPopupShow,
        } = useLogin();

        const showECommerceOrderList = computed(() => {
            return proxy?.$store?.state?.startup?.bucket === 'br';
        });

        const handleClickTopBarAvatarBtn = () => {
            if (isLoginStatus.value) {
                handleLogoutPopupShow(true);
                return;
            }
            changeLoginPopupShow(true);
        };

        const handleClickECommerceOrderList = () => {
            /**
             * @zh 本地环境测试访问 https://kwai-pwa-hzs.test.gifshow.com
             */
            window.open('/shop/order-list', '_blank');
        };

        return {
            showECommerceOrderList,
            handleClickTopBarAvatarBtn,
            handleClickECommerceOrderList,
            handleClickSearchBtn,
            showLoginPopup,
            changeLoginStatus,
            handleLoginPopupClose,
            handleLoginPopupOpenkwai,
            showLogoutPopup,
            handleLogoutCancel,
            handleLogout,
            currentUserHeadUrl,
        };
    },
});

export default ECommerceHeader;
